module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_7.d25832e9.jpg";